import styled from 'styled-components';
import { theme } from 'assets/styles/theme';
import { DeviceUp, DeviceDown } from 'assets/styles/breakpoints';

export const Styled = styled.div``;

export const MainContainer = styled.div`
  background: #ECF0F4;
  display: flex;
  flex-flow: column wrap;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  flex: 1 1 auto;

  @media ${DeviceUp.lg} {
    flex-flow: row nowrap;
    height: 100%;
  }
`;

export const ContentWrapper = styled.div`
  background: ${theme.bodyBg};
  padding: 16px;
  flex: 1 1 auto;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: clip;

  @media ${DeviceUp.sm} {
    padding: 20px;
  }

  @media ${DeviceUp.lg} {
    padding: 30px 35px;
    min-height: 350px;
  }

  @media ${DeviceUp.xl} {
    padding: 41px 60px 30px;
  }

  h1 {
    margin: 0 0 20px;
  }
`;

export const MainContent = styled.div`
  display: block;
  position: relative;
  width: 100%;
  max-width: 100%;
  min-width: 0;
`;

export const UsersPageHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  margin-bottom: 20px;

  @media ${DeviceUp.sm} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  }

  h1 {
    margin: 0;
    flex-shrink: 0;
  }
`;

export const ButtonsHolder = styled.div`
  display: flex;
  align-items: center;
  flex-flow: row wrap;
  justify-content: flex-start;
  gap: 12px;
  width: 100%;
  max-width: 100%;

  @media ${DeviceUp.sm} {
    justify-content: flex-end;
    width: auto;
    flex-shrink: 0;
  }

  > a {
    display: flex;
    flex: 0 1 auto;
    width: auto;
    max-width: 100%;
  }

  button {
    display: flex;
    margin: 0;
    white-space: nowrap;
    align-items: center;
    justify-content: center;
    vertical-align: top;
    width: auto;
    min-width: 0;
    flex: 0 1 auto;
    max-width: 100%;
    height: 48px;

    @media ${DeviceUp.sm} {
      min-width: 127px;
      flex: 0 0 auto;
      max-width: none;
    }



    &.group {
      background: none;
      color: ${theme.secondary};
      border-color: ${theme.secondary};
      color: ${theme.secondary};

      &:hover {
        background: ${theme.secondary};
        color: ${theme.bodyBg};
      }
    }

    .icon, i {
      margin: 0 12px 0 0;
      position: relative;
      font-size: 21px;

      &.right {
        margin: 0 0 0 12px;
      }
    }

    &.disabled {
      background: ${theme.lightGray};
      border-color: ${theme.lightGray};
      color: ${theme.bodyBg};
      pointer-events: none;
    }
  }

  &.v2 {
    padding-bottom: 0;
    margin-right: 0;

    @media ${DeviceUp.sm} {
      margin-right: 0;
    }

    @media ${DeviceUp.sm} {
      padding-top: 0;
    }

    button {
      @media ${DeviceUp.sm} {
        margin-bottom: 0;
      }
    }
  }

  .file-button {
      background: ${theme.primary};
      border-radius: 4px;
      height: 48px;
      text-align: center;
      color: ${theme.bodyBg};
      padding: 0 18px;
      border: 1px solid transparent;
      font-size: ${theme.lgFontSize};
      transition: linear 0.3s;
      white-space: nowrap;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      cursor: pointer;
      width: auto;
      min-width: 0;
      flex: 0 1 auto;
      max-width: 100%;

      @media ${DeviceUp.sm} {
        flex: 0 0 auto;
        max-width: none;
      }

      &:hover {
        border-color: ${theme.primary};
        color: ${theme.primary};
        background: ${theme.bodyBg};
        cursor: pointer;
      }

      input {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        opacity: 0;
        width: 100%;
        cursor: pointer;
        z-index: 1;
        font-size: 0;
        line-height: 0;
      }

      i {
        cursor: pointer;
      }
    }

`;

export const InfoBlock = styled.div`
  margin: 0 0 20px;
  width: 100%;
  max-width: 100%;

  @media ${DeviceUp.sm} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px 24px;
  }

  &.v2 {
    display: flex;
    align-items: center;
  }

  .search-block {
    height: 48px;
    position: relative;
    width: 100%;
    max-width: 100%;
    flex-shrink: 0;

    @media ${DeviceUp.sm} {
      width: 280px;
      max-width: 280px;
    }

    .clear-search {
      position: absolute;
      right: 6px;
      top: 11px;
      width: 18px;
      cursor: pointer;

      &:hover {
        path {
          stroke: ${theme.gray};
        }
      }

      svg {
        display: block;
        width: 100%;
      }

      path {
        stroke: ${theme.primary};
      }
    }

    .icon-Search-2-Outline-Color {
      font-size: 20px;
      margin: 14px 12px 12px 14px;
      position: absolute;
      left: 0;
      top: 0;
    }

    .form-control {
      padding-left: 40px;
      padding-right: 30px;
      text-overflow: ellipsis;
    }
  }
  .actions-block {
    margin: 16px 0 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px 20px;

    @media ${DeviceUp.sm} {
      margin: 0;
      flex: 1 1 auto;
      justify-content: flex-end;
      gap: 8px 24px;
    }

    @media ${DeviceUp.lg} {
      gap: 8px 32px;
    }

    > a {
      display: flex;
      align-items: center;

      &.disabled {
        pointer-events: none;
      }
    }

    button {
      background: none;
      color: ${theme.text};
      border-radius: 0;
      height: auto;
      border: 0;
      padding: 0;
      font-size: 13px;
      margin: 0;
      white-space: nowrap;

      .text-holder {
        display: flex;
        align-items: center;
      }

      .icon {
        color: ${theme.secondary};
        font-size: 18px;
        margin:  0 6px 0 0;
      }
      &:hover {
        color: ${theme.secondary};
      }
      &.disabled {
        background: none;
        color: ${theme.gray};

        .icon {
          color: ${theme.gray};
        }
      }
    }
  }
`;

export const DataBlock = styled.div`
  margin: 0 0 10px;
  width: 100%;
  max-width: 100%;

  .md-order-reverse {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;

    @media ${DeviceDown.sm} {
      flex-direction: column-reverse;
    }

    @media ${DeviceUp.sm} {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 16px 24px;
    }
  }

  .select-info {
    margin: 10px 0 0;
    padding-left: 33px;
    position: relative;
    min-height: 21px;
    flex: 1 1 auto;
    min-width: 0;

    @media ${DeviceUp.sm} {
      padding: 0;
      margin: 0;
    }
    .block {
      font-weight: 600;
      overflow: hidden;
      .info {
        display: inline-block;
        vertical-align: middle;
        margin: 0 10px 0 0;
      }
      .clear {
        display: inline-block;
        vertical-align: middle;
        color: ${theme.secondary};
        cursor: pointer;
        margin: 0 10px 0 0;
        &:hover {
          color: ${theme.text};
        }
      }
    }
    label {
      position: absolute;
      left: 0;
      top: 1px;
      @media ${DeviceUp.sm} {
        display: none;
      }
    }
  }
  .results-info {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 12px;
    flex-shrink: 0;

    .info {
      font-weight: 600;
      margin: 0;
    }

    select {
      background: ${theme.bodyBg};
      border: 1.75px solid ${theme.gray};
      border-radius: 3.5px;
      color: ${theme.textSecondary};
      outline: none;
      padding: 4px 11px 4px 5px;
      min-width: 70px;
    }
  }
`;

export const ResultsBlock = styled.div`
 font-weight: 600;
 color: ${theme.gray};

 @media ${DeviceUp.xl} {
    margin: 0 0 0 38px;
  }
 span {
  color: ${theme.text};
 }
`;

export const Pagination = styled.div`
 max-width: 400px;
 margin: -12px auto 0;
 text-align: center;
 font-weight: 600;
 ul {
   li {
     display: inline-block;
     vertical-align: middle;
     margin: 0 9px;
     a {
      color: ${theme.primary};
      &:hover {
        color: ${theme.text};
      }
     }
     &.prev,
     &.next {
       a {
        font-size: 0;
        line-height: 0;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: ${theme.primary};
        display: block;
        color: ${theme.bodyBg};
        i {
          font-size: 16px;
          line-height: 32px;
        }
        &:hover {
          background: ${theme.text};
        }
       }
     }
   }
 }
`;

export const NewUserHeader = styled.div`
  padding-bottom: 15px;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  max-width: 100%;

  h2 {
    font-size: 28px;
    font-weight: 600;
    line-height: 1.3;
    margin: 0;
    flex-shrink: 0;
  }
`;

export const AddUserForm = styled.div`
  margin: 0;
  padding: 30px 0;
  border-top: solid 2px ${theme.gray};

  @media ${DeviceUp.lg} {
    margin: 0 -35px;
    padding: 30px 35px;
  }

  @media ${DeviceUp.xl} {
    margin: 0 -60px;
    padding: 33px 60px 0;
  }

  h3 {
    font-size: 24px;
    line-height: 26px;
    margin-bottom: 13px;
  }
`;

export const FormHolder = styled.div`
  max-width: 600px;
`;

export const FormRow = styled.div`
`;

export const FormCol = styled.div`
  padding: 0 0 27px;
  width: 100%;

  &.col-6 {
    @media ${DeviceUp.sm} {
      width: 50%;
    }
  }

  label, .custom-select {
    span {
      display: block;
      font-size: 18px;
      line-height: 20px;
      font-weight: 600;
      margin-bottom: 8px;
      color: ${theme.gray};
    }
  }
`;

export const CustomSlect = styled.div`
  position: relative;

  &:before {
    position: absolute;
    right: 17px;
    top: 17px;
    content: '';
    width: 8px;
    height: 8px;
    border: solid 2px ${theme.text};
    border-width: 0 0 2px 2px;
    pointer-events: none;
    transform: rotate(-45deg);
  }
`;

export const RadioButtonsList = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin: 0 -8px;

  .radio-button {
    margin: 0 8px 16px;
    min-width: 160px;
  }

  label {
    span {
      margin: 0;
      color: ${theme.text};
      font-weight: 400;
    }
  }
`;

export const InfoText = styled.div`
  display: block;
  color: ${theme.gray};
  margin-bottom: 20px;
`;

export const SearchTags = styled.div`
  position: relative;

  .form-control {
    padding-left: 48px;
    padding-right: 40px;
  }

  &:before {
    position: absolute;
    right: 17px;
    top: 17px;
    content: '';
    width: 8px;
    height: 8px;
    border: solid 2px ${theme.text};
    border-width: 0 0 2px 2px;
    pointer-events: none;
    transform: rotate(-45deg);
    z-index: 1;
  }

  .search-icon {
    position: absolute;
    left: 15px;
    top: 12px;
    z-index: 1;
    font-size: 24px;
  }

  &.search-users {
    margin-bottom: 15px;
    z-index: 9;

    .user-select__input-container {
      margin-top: 0;
      padding-top 0;
    }
    .user-select__placeholder {
      cursor: text;
      font-size: 16px;
      color: #292c2e;
      opacity: 0.8;
    }
    .user-select__option {
      cursor: pointer;
    }
    .user-select__control {
      border: 2px solid #aaa;
      height: 48px;
      font-size: 16px;
      line-height: 28px;
      color: #292c2e;
      border-radius: 4px;
      &.user-select__control--is-focused {
        border-color: ${theme.primary};
        outline: 0;
        box-shadow: 0 0 0 3px rgba(86, 183, 247, .25);
      }
    }
    .user-select__multi-value {
      display: none;
    }
    .user-select__value-container {
      height: 35px;
      padding: 0 0 0 48px;
    }
    @media ${DeviceUp.sm} {
      width: 305px;
      margin-bottom: 0;
    }
    
    &:before {
      display: none;
    }
  }
`;

export const SearchTagsList = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  margin:  0 -5px;
  padding-top: 10px;

  @media ${DeviceUp.sm} {
    padding-top: 20px;
  }

  .tag-button {
    margin: 0 5px 10px;
    border-radius: 18px;
    padding: 5px 18px;
    background-color: ${theme.primary};
    min-height: 36px;
    line-height: 18px;
    height: auto;
    border: 0;
    color: ${theme.bodyBg};
    display: flex;
    align-items: center;
    cursor: default;
    word-break: break-all;

    button {
      margin: 0;
      padding: 0;
      background: none;
      border: 0;
      height: auto;

      &:hover {
        color: ${theme.text};

        path {
          stroke: #fff;
        }
      }
    }

    @media ${DeviceDown.sm} {
      padding:  6px 10px;
      font-size: 12px;
    }

    img {
      margin-left: 6px;
      cursor: pointer;
    }
  }

  .clear-link {
    margin-top: 8px;
    padding:  0 5px;
    color: ${theme.secondary};
    svg {
      width: 16px;
      margin: 1px 0 0 6px;
      vertical-align: top;
      height: 16px;
    }
    .icon {
      margin: 1px 0 0 6px;
      vertical-align: top;
      display: inline-block;
    }
  }
`;

export const UserInfoWrapper = styled.div`
  margin: 0;
  padding: 33px 0 10px;
  border-top: solid 2px ${theme.gray};

  @media ${DeviceUp.lg} {
    margin: 0 -35px;
    padding: 30px 35px;
  }

  @media ${DeviceUp.xl} {
    margin: 0 -60px;
    padding: 33px 60px 0;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin:  0 -15px;

  @media ${DeviceUp.xs} {
    .order-3 {
      order: 3;
    }
    .order-4 {
      order: 4;
    }
    .order-5 {
      order: 5;
    }
    .order-6 {
      order: 6;
    }
    .order-7 {
      order: 7;
    }
    .order-8 {
      order: 8;
    }
  }
`;

export const InfoCol = styled.div`
  width: 100%;
  padding:  0 15px 33px;

  &.col-6 {
    @media ${DeviceUp.xs} {
      width: 50%;
    }
  }
`;

export const InfoTitle = styled.div`
  font-size: 16px;
  color: ${theme.gray};
  font-weight: 600;
  margin: 0 0 4px;

  @media ${DeviceUp.sm} {
    font-size: 18px;
  }
`;

export const InfoDetail = styled.div`
  font-size: 20px;
  line-height: 24px;
  color: ${theme.text};
  font-weight: 600;
  word-break: break-all;

  @media ${DeviceUp.sm} {
    font-size: 24px;
    line-height: 28px;
  }
`;

export const AccountStatus = styled.div`
  font-size: 20px;
  line-height: 24px;
  color: ${theme.text};
  font-weight: 600;
  display: flex;
  align-items: center;
  padding-top: 5px;

  @media ${DeviceUp.sm} {
    font-size: 24px;
    line-height: 28px;
    padding-top: 0;
  }

  .switch {
    margin-right: 10px;
  }
`;

export const CourseDetailWrapper = styled.div`
  margin: 0;
  padding: 33px 0;
  border-top: solid 2px ${theme.gray};

  @media ${DeviceUp.lg} {
    margin: 0 -35px;
    padding: 30px 35px;
  }

  @media ${DeviceUp.xl} {
    margin: 0 -60px;
    padding: 33px 60px 18px;
  }

  .heading-holder {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding-bottom: 26px;

    h3 {
      font-size: 28px;
      line-height: 30px;
      margin: 0 !important;
    }

    .enrollment-save-bar {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-end;
      gap: 12px;

      .pending-count {
        font-size: 14px;
        font-weight: 600;
        color: ${theme.secondary};
      }

      button {
        margin: 0;
        height: 36px;
        font-size: 14px;
        padding: 0 16px;

        &.cancel {
          color: ${theme.secondary};
          border: solid 1px ${theme.secondary};
          background: ${theme.bodyBg};

          &:hover {
            border-color: ${theme.primary};
            color: ${theme.primary};
          }
        }
      }
    }
  }
`;

export const EnrolCoursesWrapper = styled.div`
  margin: 0;
  padding: 24px 0 33px;
  border-top: solid 2px ${theme.gray};
  width: 100%;
  max-width: 100%;

  @media ${DeviceUp.lg} {
    margin: 0 -35px;
    padding: 30px 35px;
  }

  @media ${DeviceUp.xl} {
    margin: 0 -60px;
    padding: 33px 60px 0;
  }

  h3 {
    font-size: 24px;
    line-height: 26px;
    margin-bottom: 20px;
  }

  .page-counter {
    margin-left: 30px;
    @media ${DeviceUp.lg} {
      margin-left: 0;
    }
  }
`;

export const SearchField = styled.div`
  position: relative;
  width: 100%;

  @media ${DeviceUp.sm} {
    width: 100%;
    max-width: 305px;
  }

  .form-control {
    padding-left: 48px;
  }

  .search-icon {
    position: absolute;
    left: 15px;
    top: 12px;
    font-size: 24px;
    z-index: 1;
  }
`;

export const SearchWrapper = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  width: 100%;
  max-width: 100%;

  @media ${DeviceUp.sm} {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 16px;
  }

  h3 {
    margin: 0;
    flex-shrink: 0;
  }

  button {
    margin: 0;
  }
`;

export const CardsList = styled.div`
  padding-bottom: 7px;
`;

export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  .checkbox {
    position: relative;
    width: 20px;
    margin:  0 12px 0 0;

    @media ${DeviceUp.lg} {
      margin:  0 7px 0 -26px;
    }

    @media ${DeviceUp.xl} {
      margin:  0 12px 0 -40px;
    }
  }

  label {
    min-width: auto;
    min-height: auto;
  }
`;

export const UsersCounter = styled.div`
  font-size: 18px;
  color: ${theme.gray};
  flex-shrink: 0;

  @media ${DeviceUp.sm} {
    text-align: right;
  }
`;

export const TopSearchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  width: 100%;
  max-width: 100%;

  @media ${DeviceUp.sm} {
    align-items: flex-end;
    flex-direction: row-reverse;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 16px;
  }

  .select-search__input {
    padding: 8px 30px 8px 46px;
  }
`;

export const TagsListWrapper = styled.div`
  padding-bottom: 20px;

  @media ${DeviceUp.sm} {
    padding-bottom: 48px;
  }
`;

export const TextCenter = styled.div`
  text-align: center;
`;

export const ExpanderButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ProgressBar = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  .progress {
    flex: 1;
    height: 20px;
    position: relative;
    margin-right: 40px;

    .bar {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      min-width: 1px;
      background: ${theme.secondary};

      span {
        font-size: 12px;
        width: 40px;
        text-align: right;
        position: absolute;
        left: 100%;
        top: 3px;
      }
    }
  }
`;

export const ExpanderButton = styled.span`
  color: ${theme.secondary};
  font-size: 16px;
  line-height: 18px;
  cursor: pointer;

  i {
    margin: 4px 0 0 8px;
    display: inline-block;
    vertical-align: top;
  }
`;

export const ErrorSpan = styled.span`
  color: ${'#FF7A00'};
`;

export const HeadingButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 15px;

  @media ${DeviceUp.sm} {
    padding-bottom: 0;
  }

  h3 {
    margin-bottom: 0;
  }
  button {
    &.link {
      color: ${theme.secondary};

      &:hover {
        text-decoration: none;
      }
      i {
        display: inline-block;
        vertical-align: top;
        margin:  3px 0 0 6px;
      }
    }
  }
`;

export const PopupBox = styled.div`
  border-radius: 16px;
  background-color: ${theme.bodyBg};
  max-width: 680px;
  padding:  30px;
  flex-grow: 1;
  position: relative;

  @media ${DeviceUp.sm} {
    padding:  40px 40px 35px;
    border-radius: 24px;
  }

  label {
    color: ${theme.lightGray};
    margin:  0 0 30px;
    display: block;
    @media ${DeviceUp.sm} {
      margin:  0 0 83px;
    }
    span {
      display: block;
      margin:  0 0 5px;
    }
  }

  h2 {
    margin:  0 0 25px;

    @media ${DeviceUp.sm} {
      margin:  0 0 60px;
    }
  }

  .close-button {
    position: absolute;
    right: 20px;
    top: 15px;
    width: auto;
    height: auto;
    padding: 0;
    border-radius: 0;
    background: none;
    opacity: 0.35;
    border: 0;
    font-size: 20px;
    color: ${theme.text};

    @media ${DeviceUp.sm} {
      right: 35px;
      top: 23px;
    }
  }
`;

export const PopUpButtonsHolder = styled.div`
  display: flex;
  justify-content: flex-start;

  @media ${DeviceUp.sm} {
    justify-content: flex-end;
  }

  button {
    margin: 0 11px;
    min-width: 101px;
  }
`;
